import { observer } from 'mobx-react-lite'
import { type JobRootViewModel } from '@/features/jobs/details/JobRootViewModel'
import { JobErrorContainer } from '@/features/jobs/components/JobErrorContainer'
import type { JobDetailsViewLoaderData } from '@/features/jobs/job-route-loaders'
import { ContentLoading } from '@/components/ContentLoading'
import { AccessDeniedView } from '@/components/AccessDeniedView'
import { MobileJob } from '@/features/jobs/details/components/MobileJob'
import { MobileJobBodyContainer } from './MobileJobBodyContainer'
import { useActivation } from '@/hooks/view-model-hooks'
import { useHideHubspotWidget } from '@/features/tracking/hubspot-widget-visibility'
import { useFeatures } from '@/contexts/root-store-context'

export interface MobileJobRootContainerProps {
  rootVm: JobRootViewModel
  data: JobDetailsViewLoaderData
  error?: unknown
}

export const MobileJobRootContainer = observer(function MobileJobRootContainer({
  rootVm,
  data,
  error,
}: MobileJobRootContainerProps) {
  const { shellInfo } = useFeatures(({ shell }) => ({
    shellInfo: shell.shellInfo,
  }))
  useHideHubspotWidget()
  useActivation(rootVm)

  return (
    <MobileJob>
      {error ? (
        <JobErrorContainer error={error} />
      ) : !data ? (
        <ContentLoading />
      ) : 'denied' in data ? (
        <AccessDeniedView
          corporateMode={shellInfo.corporateMode}
          title={data.denied}
        />
      ) : (
        <MobileJobBodyContainer vm={data.vm} />
      )}
    </MobileJob>
  )
})
